import React, { useEffect, useState } from 'react';
import config from '../config';
import { Link, useParams } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';

const NewProduct = ({ testMode = false }) => {

    // const host = testMode ? config.testBackendUrl : config.backendUrl;
    const host = config.backendUrl;
    const productId = useParams().productId;

    const [product, setProduct] = useState(null);
    const [authToken, setAuthToken] = useState('');
    const [loading, setLoading] = useState(true);

    const [productDetails, setProductDetails] = useState({
        name: '',
        id: '',
        description: '',
        price: 0.00,
        category: '',
    });

    useEffect(() => {
        const getAuthToken = async () => {
            try {
                const session = await fetchAuthSession();
                const token = session.tokens.idToken.toString();
                setAuthToken(token);
            } catch (error) {
                console.error('Error getting auth token:', error);
            }
        };
        
        getAuthToken();
    }, []);

    const handleSaveProduct = async () => {
        if (!authToken) {
            console.error('No auth token available');
            return;
        }

        const newProductData = {
            name: productDetails.name,
            id: productDetails.id,
            description: productDetails.description,
            price: productDetails.price,
            category: productDetails.category,
            currency: 'USD', // Default currency
            s3_folder: productDetails.id
        };

        try {
            const response = await fetch(`${host}/api/admin/products`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify(newProductData)
            });
            
            if (!response.ok) {
                console.error('Error saving product:', response.statusText);
                return;
            }
            
            const savedProduct = await response.json();
            console.log('Product saved successfully:', savedProduct);
            // Redirect to product details page
            window.location.href = testMode ? `/test/products/${productDetails.id}` : `/products/${productDetails.id}`;
        } catch (error) {
            console.error('Error saving product:', error);
        }
    };

    return (
        <div className="main-content">
            {/* Page Header */}
            <div className="page-header">
                <div className="page-header-left">
                    <h1 className="page-header-title">
                        New Product
                        {testMode && <span style={{color: 'var(--warning-color)'}}> (Test Mode)</span>}
                    </h1>
                </div>
                <div className="page-header-actions">
                    <Link to={testMode ? "/test/products" : "/products"} className="btn btn-secondary">
                        ← Back to Products
                    </Link>
                    <button className="btn btn-primary" style={{ marginLeft: 'var(--spacing-md)' }} onClick={handleSaveProduct}>
                        Save Product
                    </button>
                </div>
            </div>

            {/* Product Information */}
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">General Information</h3>
                </div>
                <div className="card-body">
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--spacing-lg)' }}>
                        <div>
                            <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                                <label className="form-label">Product ID</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={productDetails.id}
                                    onChange={(e) => setProductDetails({ ...productDetails, id: e.target.value })}
                                />
                            </div>
                            
                            <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                                <label className="form-label">Product Name</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={productDetails.name}
                                    onChange={(e) => setProductDetails({ ...productDetails, name: e.target.value })}
                                />
                            </div>
                        </div>
                        
                        <div>
                            <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                                <label className="form-label">Price (in cents)</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-input"
                                    value={productDetails.price}
                                    onChange={(e) => setProductDetails({ ...productDetails, price: parseFloat(e.target.value) })}
                                />
                            </div>
                            
                            <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                                <label className="form-label">Category</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={productDetails.category}
                                    onChange={(e) => setProductDetails({ ...productDetails, category: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div style={{ marginTop: 'var(--spacing-lg)' }}>
                        <label className="form-label">Description</label>
                        <textarea
                            className="form-textarea"
                            rows="4"
                            value={productDetails.description}
                            onChange={(e) => setProductDetails({ ...productDetails, description: e.target.value })}
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewProduct;